import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setAlertError, setAlertInfo, setAlertSuccess } from '../alert/alertSlice';
import greenService from './greenService';

export const getAllPatterns = createAsyncThunk('event/getAllPatterns', async (_, thunkAPI) => {
  return await greenService
    .getAllPatterns()
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const getPatternById = createAsyncThunk('event/getPatternById', async (id, thunkAPI) => {
  return await greenService
    .getPatternById(id)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      const err = error.response.data;
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const createPattern = createAsyncThunk('event/createPattern', async (data, thunkAPI) => {
  return await greenService
    .createPattern(data)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Pattern created successfully'));
      return response?.id && response?.id?.id ? response.id : response;
    })
    .catch((error) => {
      const err = error.response.data;
      thunkAPI.dispatch(setAlertError(err.message));
      return thunkAPI.rejectWithValue(err.message);
    });
});

export const deletePattern = createAsyncThunk('event/deletePattern', async (id, thunkAPI) => {
  return await greenService
    .deletePattern(id)
    .then((response) => {
      thunkAPI.dispatch(setAlertSuccess('Pattern deleted successfully'));
      return response;
    })
    .catch((error) => {
      const err = error.response?.data;
      const message = err?.message || err || 'Failed to delete pattern';
      thunkAPI.dispatch(setAlertError(message));
      return thunkAPI.rejectWithValue(message);
    });
});

export const getGreenPlayerInformation = createAsyncThunk(
  'green/getGreenPlayerInformation',
  async (eventId, thunkAPI) => {
    return await greenService
      .getGreenPlayerInformation(eventId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const greenSlice = createSlice({
  name: 'green',
  initialState: {
    patterns: [],
    pattern: null,
    isLoading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllPatterns.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPatterns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.patterns = action.payload;
      })
      .addCase(getAllPatterns.rejected, (state, action) => {
        state.isLoading = false;
        state.patterns = [];
        state.error = action.payload;
      })
      .addCase(getPatternById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPatternById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pattern = action.payload;
      })
      .addCase(getPatternById.rejected, (state, action) => {
        state.isLoading = false;
        state.pattern = null;
        state.error = action.payload;
      })
      .addCase(createPattern.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPattern.fulfilled, (state, action) => {
        state.isLoading = false;
        state.patterns.push(action.payload);
      })
      .addCase(createPattern.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deletePattern.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePattern.fulfilled, (state, action) => {
        state.isLoading = false;
        state.patterns = state.patterns.filter((pattern) => pattern.id !== action.payload?.id);
      })
      .addCase(deletePattern.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getGreenPlayerInformation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGreenPlayerInformation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.greenPlayerInformation = action.payload;
      })
      .addCase(getGreenPlayerInformation.rejected, (state, action) => {
        state.isLoading = false;
        state.greenPlayerInformation = null;
        state.error = action.payload;
      });
  }
});

export const {} = greenSlice.actions;
export default greenSlice.reducer;
